"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function RectangleLgSvg(t0) {
  const $ = _c(195);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        const t2 = `${id}-bright-blue`;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[4] = t2;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = `url(#${id}-bright-blue)`;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#5375CF" />;
          $[6] = t6;
        } else {
          t6 = $[6];
        }
        let t7;
        if ($[7] !== style) {
          t7 = <motion.path opacity={0.4} d="M1440 952H799V631.959C799 455.211 942.517 312 1119.46 312C1296.4 312 1440 455.293 1440 631.959V952Z" fill="#4668C2" style={style("bottom right")} />;
          $[7] = style;
          $[8] = t7;
        } else {
          t7 = $[8];
        }
        let t8;
        if ($[9] !== style) {
          t8 = <motion.path opacity={0.7} d="M479 -266L1120 -266L1120 54.5412C1120 231.565 976.483 375 799.541 375C622.6 375 479 231.483 479 54.5413L479 -266Z" fill="#4668C2" style={style("top center")} />;
          $[9] = style;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== t5 || $[12] !== t7 || $[13] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[11] = t5;
          $[12] = t7;
          $[13] = t8;
          $[14] = t9;
        } else {
          t9 = $[14];
        }
        let t10;
        if ($[15] !== t4 || $[16] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[15] = t4;
          $[16] = t9;
          $[17] = t10;
        } else {
          t10 = $[17];
        }
        return t10;
      }
    case "light-green":
      {
        const t2 = `${id}-light-green`;
        let t3;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[19] = t2;
          $[20] = t4;
        } else {
          t4 = $[20];
        }
        const t5 = `url(#${id}-light-green)`;
        let t6;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#9BD7D2" />;
          $[21] = t6;
        } else {
          t6 = $[21];
        }
        let t7;
        if ($[22] !== style) {
          t7 = <motion.path opacity={0.4} d="M1768 750H1068V399.955C1068 206.637 1224.73 50 1417.95 50C1611.18 50 1768 206.727 1768 399.955V750Z" fill="#85CDC7" style={style("bottom right")} />;
          $[22] = style;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        let t8;
        if ($[24] !== style) {
          t8 = <motion.path opacity={0.7} d="M368 -1.60793e-07L1068 6.10352e-05L1068 350.045C1068 543.363 911.273 700 718.045 700C524.817 700 368 543.273 368 350.045L368 -1.60793e-07Z" fill="#85CDC7" style={style("center left")} />;
          $[24] = style;
          $[25] = t8;
        } else {
          t8 = $[25];
        }
        let t9;
        if ($[26] !== t5 || $[27] !== t7 || $[28] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[26] = t5;
          $[27] = t7;
          $[28] = t8;
          $[29] = t9;
        } else {
          t9 = $[29];
        }
        let t10;
        if ($[30] !== t4 || $[31] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[30] = t4;
          $[31] = t9;
          $[32] = t10;
        } else {
          t10 = $[32];
        }
        return t10;
      }
    case "turquoise":
      {
        const t2 = `${id}-turquoise`;
        let t3;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[33] = t3;
        } else {
          t3 = $[33];
        }
        let t4;
        if ($[34] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[34] = t2;
          $[35] = t4;
        } else {
          t4 = $[35];
        }
        const t5 = `url(#${id}-turquoise)`;
        let t6;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#00968C" />;
          $[36] = t6;
        } else {
          t6 = $[36];
        }
        let t7;
        if ($[37] !== style) {
          t7 = <motion.circle cx="871.5" cy="592.5" r="236.5" fill="#00A399" style={style("center center")} />;
          $[37] = style;
          $[38] = t7;
        } else {
          t7 = $[38];
        }
        let t8;
        if ($[39] !== style) {
          t8 = <motion.rect opacity={0.65} x="635" y="-117" width="473" height="473" rx="40" fill="#00A399" style={style("top center")} />;
          $[39] = style;
          $[40] = t8;
        } else {
          t8 = $[40];
        }
        let t9;
        if ($[41] !== style) {
          t9 = <motion.circle cx="1344.5" cy="119.5" r="236.5" fill="#00A399" style={style("top right")} />;
          $[41] = style;
          $[42] = t9;
        } else {
          t9 = $[42];
        }
        let t10;
        if ($[43] !== style) {
          t10 = <motion.rect opacity={0.65} x="1108" y="356" width="473" height="473" rx="40" fill="#00A399" style={style("bottom right")} />;
          $[43] = style;
          $[44] = t10;
        } else {
          t10 = $[44];
        }
        let t11;
        if ($[45] !== t10 || $[46] !== t5 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[45] = t10;
          $[46] = t5;
          $[47] = t7;
          $[48] = t8;
          $[49] = t9;
          $[50] = t11;
        } else {
          t11 = $[50];
        }
        let t12;
        if ($[51] !== t11 || $[52] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[51] = t11;
          $[52] = t4;
          $[53] = t12;
        } else {
          t12 = $[53];
        }
        return t12;
      }
    case "peach":
      {
        const t2 = `${id}-peach`;
        let t3;
        if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[54] = t3;
        } else {
          t3 = $[54];
        }
        let t4;
        if ($[55] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[55] = t2;
          $[56] = t4;
        } else {
          t4 = $[56];
        }
        const t5 = `url(#${id}-peach)`;
        let t6;
        if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#FFB497" />;
          $[57] = t6;
        } else {
          t6 = $[57];
        }
        let t7;
        if ($[58] !== style) {
          t7 = <motion.path opacity={0.7} d="M709.739 746.365H291V327.68C290.904 147.449 437.007 1.36523 617.261 1.36523H1036V420.05C1036 600.281 889.897 746.365 709.643 746.365" fill="#FFAF8F" style={style("center left")} />;
          $[58] = style;
          $[59] = t7;
        } else {
          t7 = $[59];
        }
        let t8;
        if ($[60] !== style) {
          t8 = <motion.path opacity={0.7} d="M1454.18 750.365H1036V332.242C1035.9 152.253 1181.81 6.36523 1361.82 6.36523H1780V424.488C1780 604.477 1634.09 750.365 1454.08 750.365" fill="#F8A98A" style={style("center right")} />;
          $[60] = style;
          $[61] = t8;
        } else {
          t8 = $[61];
        }
        let t9;
        if ($[62] !== t5 || $[63] !== t7 || $[64] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[62] = t5;
          $[63] = t7;
          $[64] = t8;
          $[65] = t9;
        } else {
          t9 = $[65];
        }
        let t10;
        if ($[66] !== t4 || $[67] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[66] = t4;
          $[67] = t9;
          $[68] = t10;
        } else {
          t10 = $[68];
        }
        return t10;
      }
    case "avocado":
      {
        const t2 = `${id}-avocado`;
        let t3;
        if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[69] = t3;
        } else {
          t3 = $[69];
        }
        let t4;
        if ($[70] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[70] = t2;
          $[71] = t4;
        } else {
          t4 = $[71];
        }
        const t5 = `url(#${id}-avocado)`;
        let t6;
        if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#CCE88A" />;
          $[72] = t6;
        } else {
          t6 = $[72];
        }
        let t7;
        if ($[73] !== style) {
          t7 = <motion.path d="M1195.38 -86.7861L740.882 367.714L1195.38 822.214L1649.88 367.714L1195.38 -86.7861Z" fill="#C2E079" style={style("center right")} />;
          $[73] = style;
          $[74] = t7;
        } else {
          t7 = $[74];
        }
        let t8;
        if ($[75] !== style) {
          t8 = <motion.path d="M741.5 -86.7861L287 367.714L741.5 822.214L1196 367.714L741.5 -86.7861Z" fill="#C6E57D" style={style("center left")} />;
          $[75] = style;
          $[76] = t8;
        } else {
          t8 = $[76];
        }
        let t9;
        if ($[77] !== t5 || $[78] !== t7 || $[79] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[77] = t5;
          $[78] = t7;
          $[79] = t8;
          $[80] = t9;
        } else {
          t9 = $[80];
        }
        let t10;
        if ($[81] !== t4 || $[82] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[81] = t4;
          $[82] = t9;
          $[83] = t10;
        } else {
          t10 = $[83];
        }
        return t10;
      }
    case "sky-blue":
      {
        const t2 = `${id}-sky-blue`;
        let t3;
        if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[84] = t3;
        } else {
          t3 = $[84];
        }
        let t4;
        if ($[85] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[85] = t2;
          $[86] = t4;
        } else {
          t4 = $[86];
        }
        const t5 = `url(#${id}-sky-blue)`;
        let t6;
        if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#A6B9F1" />;
          $[87] = t6;
        } else {
          t6 = $[87];
        }
        let t7;
        if ($[88] !== style) {
          t7 = <motion.path d="M757.301 746H338V326.753C337.904 146.28 484.203 0 664.699 0H1084V419.247C1084 599.72 937.701 746 757.205 746" fill="#9BB1EF" style={style("center left")} />;
          $[88] = style;
          $[89] = t7;
        } else {
          t7 = $[89];
        }
        let t8;
        if ($[90] !== style) {
          t8 = <motion.path d="M1503.3 750H1084V330.753C1083.9 150.28 1230.2 4 1410.7 4H1830V423.247C1830 603.72 1683.7 750 1503.2 750" fill="#90A7E7" style={style("center right")} />;
          $[90] = style;
          $[91] = t8;
        } else {
          t8 = $[91];
        }
        let t9;
        if ($[92] !== t5 || $[93] !== t7 || $[94] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[92] = t5;
          $[93] = t7;
          $[94] = t8;
          $[95] = t9;
        } else {
          t9 = $[95];
        }
        let t10;
        if ($[96] !== t4 || $[97] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[96] = t4;
          $[97] = t9;
          $[98] = t10;
        } else {
          t10 = $[98];
        }
        return t10;
      }
    case "orange":
      {
        const t2 = `${id}-orange`;
        let t3;
        if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[99] = t3;
        } else {
          t3 = $[99];
        }
        let t4;
        if ($[100] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[100] = t2;
          $[101] = t4;
        } else {
          t4 = $[101];
        }
        const t5 = `url(#${id}-orange)`;
        let t6;
        if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#F0B464" />;
          $[102] = t6;
        } else {
          t6 = $[102];
        }
        let t7;
        if ($[103] !== style) {
          t7 = <motion.path opacity={0.4} d="M1440 944C1440 948.418 1436.42 952 1432 952H807C802.582 952 799 948.418 799 944V631.959C799 455.211 942.517 312 1119.46 312C1296.4 312 1440 455.293 1440 631.959V944Z" fill="#EFAC53" style={style("bottom right")} />;
          $[103] = style;
          $[104] = t7;
        } else {
          t7 = $[104];
        }
        let t8;
        if ($[105] !== style) {
          t8 = <motion.path opacity={0.7} d="M479 -258C479 -262.418 482.582 -266 487 -266L1112 -266C1116.42 -266 1120 -262.418 1120 -258L1120 54.5412C1120 231.565 976.483 375 799.541 375C622.6 375 479 231.483 479 54.5413L479 -258Z" fill="#EFAC53" style={style("top center")} />;
          $[105] = style;
          $[106] = t8;
        } else {
          t8 = $[106];
        }
        let t9;
        if ($[107] !== t5 || $[108] !== t7 || $[109] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[107] = t5;
          $[108] = t7;
          $[109] = t8;
          $[110] = t9;
        } else {
          t9 = $[110];
        }
        let t10;
        if ($[111] !== t4 || $[112] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[111] = t4;
          $[112] = t9;
          $[113] = t10;
        } else {
          t10 = $[113];
        }
        return t10;
      }
    case "sea":
      {
        const t2 = `${id}-sea`;
        let t3;
        if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[114] = t3;
        } else {
          t3 = $[114];
        }
        let t4;
        if ($[115] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[115] = t2;
          $[116] = t4;
        } else {
          t4 = $[116];
        }
        const t5 = `url(#${id}-sea)`;
        let t6;
        if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#007190" />;
          $[117] = t6;
        } else {
          t6 = $[117];
        }
        let t7;
        if ($[118] !== style) {
          t7 = <motion.path opacity={0.4} d="M1724 750H1023V399.455C1023 205.861 1179.95 49 1373.45 49C1566.96 49 1724 205.951 1724 399.455V750Z" fill="#008AAA" style={style("bottom right")} />;
          $[118] = style;
          $[119] = t7;
        } else {
          t7 = $[119];
        }
        let t8;
        if ($[120] !== style) {
          t8 = <motion.path opacity={0.7} d="M322 -2.48215e-07L1023 6.10352e-05L1023 350.545C1023 544.139 866.049 701 672.545 701C479.041 701 322 544.049 322 350.545L322 -2.48215e-07Z" fill="#008AAA" style={style("center left")} />;
          $[120] = style;
          $[121] = t8;
        } else {
          t8 = $[121];
        }
        let t9;
        if ($[122] !== t5 || $[123] !== t7 || $[124] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[122] = t5;
          $[123] = t7;
          $[124] = t8;
          $[125] = t9;
        } else {
          t9 = $[125];
        }
        let t10;
        if ($[126] !== t4 || $[127] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[126] = t4;
          $[127] = t9;
          $[128] = t10;
        } else {
          t10 = $[128];
        }
        return t10;
      }
    case "mint":
      {
        const t2 = `${id}-mint`;
        let t3;
        if ($[129] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[129] = t3;
        } else {
          t3 = $[129];
        }
        let t4;
        if ($[130] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[130] = t2;
          $[131] = t4;
        } else {
          t4 = $[131];
        }
        const t5 = `url(#${id}-mint)`;
        let t6;
        if ($[132] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#86CD9F" />;
          $[132] = t6;
        } else {
          t6 = $[132];
        }
        let t7;
        if ($[133] !== style) {
          t7 = <motion.path d="M758.615 744.365H341V326.804C340.904 147.057 486.615 1.36523 666.385 1.36523H1084V418.926C1084 598.673 938.289 744.365 758.519 744.365" fill="#77C793" style={style("center left")} />;
          $[133] = style;
          $[134] = t7;
        } else {
          t7 = $[134];
        }
        let t8;
        if ($[135] !== style) {
          t8 = <motion.path d="M1501.61 748.635H1084V331.074C1083.9 151.327 1229.62 5.63477 1409.39 5.63477H1827V423.196C1827 602.943 1681.29 748.635 1501.52 748.635" fill="#6EC18B" style={style("center right")} />;
          $[135] = style;
          $[136] = t8;
        } else {
          t8 = $[136];
        }
        let t9;
        if ($[137] !== t5 || $[138] !== t7 || $[139] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[137] = t5;
          $[138] = t7;
          $[139] = t8;
          $[140] = t9;
        } else {
          t9 = $[140];
        }
        let t10;
        if ($[141] !== t4 || $[142] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[141] = t4;
          $[142] = t9;
          $[143] = t10;
        } else {
          t10 = $[143];
        }
        return t10;
      }
    case "yellow":
      {
        const t2 = `${id}-yellow`;
        let t3;
        if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[144] = t3;
        } else {
          t3 = $[144];
        }
        let t4;
        if ($[145] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[145] = t2;
          $[146] = t4;
        } else {
          t4 = $[146];
        }
        const t5 = `url(#${id}-yellow)`;
        let t6;
        if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#FFD152" />;
          $[147] = t6;
        } else {
          t6 = $[147];
        }
        let t7;
        if ($[148] !== style) {
          t7 = <motion.path d="M1139.38 -86.7861L684.882 367.714L1139.38 822.214L1593.88 367.714L1139.38 -86.7861Z" fill="#FFCC3D" style={style("center right")} />;
          $[148] = style;
          $[149] = t7;
        } else {
          t7 = $[149];
        }
        let t8;
        if ($[150] !== style) {
          t8 = <motion.path d="M685.5 -86.7861L231 367.714L685.5 822.214L1140 367.714L685.5 -86.7861Z" fill="#FFCC3D" style={style("center left")} />;
          $[150] = style;
          $[151] = t8;
        } else {
          t8 = $[151];
        }
        let t9;
        if ($[152] !== t5 || $[153] !== t7 || $[154] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[152] = t5;
          $[153] = t7;
          $[154] = t8;
          $[155] = t9;
        } else {
          t9 = $[155];
        }
        let t10;
        if ($[156] !== t4 || $[157] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[156] = t4;
          $[157] = t9;
          $[158] = t10;
        } else {
          t10 = $[158];
        }
        return t10;
      }
    case "cobalt":
      {
        const t2 = `${id}-cobalt`;
        let t3;
        if ($[159] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[159] = t3;
        } else {
          t3 = $[159];
        }
        let t4;
        if ($[160] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[160] = t2;
          $[161] = t4;
        } else {
          t4 = $[161];
        }
        const t5 = `url(#${id}-cobalt)`;
        let t6;
        if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#2B52B8" />;
          $[162] = t6;
        } else {
          t6 = $[162];
        }
        let t7;
        if ($[163] !== style) {
          t7 = <motion.path opacity={0.4} d="M1440 944C1440 948.418 1436.42 952 1432 952H807C802.582 952 799 948.418 799 944V631.959C799 455.211 942.517 312 1119.46 312C1296.4 312 1440 455.293 1440 631.959V944Z" fill="#2F5FD6" style={style("bottom right")} />;
          $[163] = style;
          $[164] = t7;
        } else {
          t7 = $[164];
        }
        let t8;
        if ($[165] !== style) {
          t8 = <motion.path opacity={0.7} d="M479 -258C479 -262.418 482.582 -266 487 -266L1112 -266C1116.42 -266 1120 -262.418 1120 -258L1120 54.5412C1120 231.565 976.483 375 799.541 375C622.6 375 479 231.483 479 54.5413L479 -258Z" fill="#2F5FD6" style={style("top center")} />;
          $[165] = style;
          $[166] = t8;
        } else {
          t8 = $[166];
        }
        let t9;
        if ($[167] !== t5 || $[168] !== t7 || $[169] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[167] = t5;
          $[168] = t7;
          $[169] = t8;
          $[170] = t9;
        } else {
          t9 = $[170];
        }
        let t10;
        if ($[171] !== t4 || $[172] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[171] = t4;
          $[172] = t9;
          $[173] = t10;
        } else {
          t10 = $[173];
        }
        return t10;
      }
    case "ocean":
      {
        const t2 = `${id}-ocean`;
        let t3;
        if ($[174] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="750" fill="white" />;
          $[174] = t3;
        } else {
          t3 = $[174];
        }
        let t4;
        if ($[175] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[175] = t2;
          $[176] = t4;
        } else {
          t4 = $[176];
        }
        const t5 = `url(#${id}-ocean)`;
        let t6;
        if ($[177] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="750" fill="#1A3C82" />;
          $[177] = t6;
        } else {
          t6 = $[177];
        }
        let t7;
        if ($[178] !== style) {
          t7 = <motion.ellipse opacity={0.34} cx="776.5" cy="643" rx="268.5" ry="268" fill="#4264B8" style={style("bottom center")} />;
          $[178] = style;
          $[179] = t7;
        } else {
          t7 = $[179];
        }
        let t8;
        if ($[180] !== style) {
          t8 = <motion.rect x="508" y="-162" width="537" height="537" rx="40" fill="#3254A2" style={style("top center")} />;
          $[180] = style;
          $[181] = t8;
        } else {
          t8 = $[181];
        }
        let t9;
        if ($[182] !== style) {
          t9 = <motion.ellipse cx="1313" cy="106.5" rx="268" ry="268.5" fill="#284A94" style={style("top right")} />;
          $[182] = style;
          $[183] = t9;
        } else {
          t9 = $[183];
        }
        let t10;
        if ($[184] !== style) {
          t10 = <motion.rect x="1045" y="375" width="536" height="536" rx="40" fill="#3254A2" style={style("bottom right")} />;
          $[184] = style;
          $[185] = t10;
        } else {
          t10 = $[185];
        }
        let t11;
        if ($[186] !== t10 || $[187] !== t5 || $[188] !== t7 || $[189] !== t8 || $[190] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[186] = t10;
          $[187] = t5;
          $[188] = t7;
          $[189] = t8;
          $[190] = t9;
          $[191] = t11;
        } else {
          t11 = $[191];
        }
        let t12;
        if ($[192] !== t11 || $[193] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 750" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[192] = t11;
          $[193] = t4;
          $[194] = t12;
        } else {
          t12 = $[194];
        }
        return t12;
      }
    default:
      {
        return null;
      }
  }
}
const RectangleLgColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-[48/25]";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <RectangleLgSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
RectangleLgColorBlock.displayName = "RectangleLgColorBlock";
export { RectangleLgColorBlock };